import { AsyncLoad, RoutesConfig } from '@ke/loreux'
// loading 骨架图等组件页
import { CommonPageLoading } from './loading'

const routes: RoutesConfig = [
  {
    // 券列表
    key: 'CouponList',
    path: ['/grow_plat/spring_renew/coupon'],
    model: () => import('pages/CouponList/model'),
    component: AsyncLoad({
      loader: () => import('pages/CouponList/index'),
      modules: ['pages/CouponList/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      uicode: 'coupon_page',
    },
  },
  {
    // 券详情
    key: 'SubCoupon',
    path: ['/grow_plat/spring_renew/subcoupon'],
    model: () => import('pages/SubCoupon/model'),
    component: AsyncLoad({
      loader: () => import('pages/SubCoupon/index'),
      modules: ['pages/SubCoupon/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      uicode: 'subcoupon_page',
    },
  },
  {
    // 券核销页面
    key: 'HxCoupon',
    path: ['/grow_plat/spring_renew/hxcoupon'],
    model: () => import('pages/HxCoupon/model'),
    component: AsyncLoad({
      loader: () => import('pages/HxCoupon/index'),
      modules: ['pages/HxCoupon/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      uicode: 'hxcoupon_page',
    },
  },
  {
    // 贝壳找房落地页
    key: 'Invite',
    path: ['/mzhan/zhuanti/invite'],
    model: () => import('pages/Invite/model'),
    component: AsyncLoad({
      loader: () => import('pages/Invite/index'),
      modules: ['pages/Invite/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      uicode: 'invite_page',
    },
  },
  {
    // m站落地页
    key: 'LandingPage',
    path: ['/landing_page/h5'],
    model: () => import('pages/LandingPage/model'),
    component: AsyncLoad({
      loader: () => import('pages/LandingPage/index'),
      modules: ['pages/LandingPage/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      uicode: 'landing_page',
    },
  },
  {
    // 贝壳会员页
    key: 'Page',
    path: ['/vip-home'],
    model: () => import('pages/MemberCenter/model'),
    component: AsyncLoad({
      loader: () => import('pages/MemberCenter/index'),
      modules: ['pages/MemberCenter/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      keepAlive: true,
      uicode: 'm_pages_beike_member',
    },
  },
  /**
   * 下面是岛屋的h5页面
   */
  {
    // 公益
    key: 'PublicBenefit',
    path: ['/neverland/publicBenefit'],
    model: () => import('pages/Neverland/PublicBenefit/model'),
    component: AsyncLoad({
      loader: () => import('pages/Neverland/PublicBenefit/index'),
      modules: ['pages/Neverland/PublicBenefit/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      keepAlive: true,
      uicode: 'neverland_publicBenefit',
    },
  },
  {
    // 提现
    key: 'Widthdraw',
    path: ['/neverland/widthdraw'],
    model: () => import('pages/Neverland/Widthdraw/model'),
    component: AsyncLoad({
      loader: () => import('pages/Neverland/Widthdraw/index'),
      modules: ['pages/Neverland/Widthdraw/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      keepAlive: true,
      uicode: 'neverland_widthdraw',
    },
  },
  {
    // 提现
    key: 'WidthdrawRecord',
    path: ['/neverland/widthdrawRecord'],
    model: () => import('pages/Neverland/Record/model'),
    component: AsyncLoad({
      loader: () => import('pages/Neverland/Record/index'),
      modules: ['pages/Neverland/Record/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      keepAlive: true,
      uicode: 'neverland_widthdraw_record',
    },
  },
  {
    // 中秋跑赢月饼
    key: 'MidAutumnGame',
    path: ['/mid-autumn-game'],
    model: () => import('pages/midAutumnGame/model'),
    component: AsyncLoad({
      loader: () => import('pages/midAutumnGame/index'),
      modules: ['pages/midAutumnGame/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      keepAlive: true,
      uicode: 'm_pages_daowu_autumn_running',
    },
  },
  {
    // 中秋跑赢月饼
    key: 'MidAutumnGameIndex',
    path: ['/mid-autumn-game-index'],
    model: () => import('pages/midAutumnGameIndex/model'),
    component: AsyncLoad({
      loader: () => import('pages/midAutumnGameIndex/index'),
      modules: ['pages/midAutumnGameIndex/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      keepAlive: true,
      uicode: 'm_pages_daowu_running_game',
    },
  },
  {
    // 中秋跑赢月饼
    key: 'midAutumnGameResult',
    path: ['/mid-autumn-game-result'],
    model: () => import('pages/midAutumnGameResult/model'),
    component: AsyncLoad({
      loader: () => import('pages/midAutumnGameResult/index'),
      modules: ['pages/midAutumnGameResult/index'],
      loading: CommonPageLoading,
    }),
    loadingComponent: CommonPageLoading,
    meta: {
      keepAlive: true,
      uicode: 'm_pages_moon_cake',
    },
  },
  {
    key: 'notfound',
    path: ['/*'],
    component: AsyncLoad({
      loader: () => import('pages/404'),
      modules: ['pages/404'],
    }),
    meta: {
      title: '页面不见了~',
      uicode: '404',
    },
  },
]
export default routes
